// WARNING: This file is autogenerated by @atomic-ehr/codegen.
// GitHub: https://github.com/atomic-ehr/codegen
// Any manual changes made to this file may be overwritten.

import type { BackboneElement } from "../hl7-fhir-r4-core/BackboneElement";
import type { CodeableConcept } from "../hl7-fhir-r4-core/CodeableConcept";
import type { Coding } from "../hl7-fhir-r4-core/Coding";
import type { ContactDetail } from "../hl7-fhir-r4-core/ContactDetail";
import type { DomainResource } from "../hl7-fhir-r4-core/DomainResource";
import type { Identifier } from "../hl7-fhir-r4-core/Identifier";
import type { UsageContext } from "../hl7-fhir-r4-core/UsageContext";

export type { BackboneElement } from "../hl7-fhir-r4-core/BackboneElement";
export type { CodeableConcept } from "../hl7-fhir-r4-core/CodeableConcept";
export type { Coding } from "../hl7-fhir-r4-core/Coding";
export type { ContactDetail } from "../hl7-fhir-r4-core/ContactDetail";
export type { Identifier } from "../hl7-fhir-r4-core/Identifier";
export type { UsageContext } from "../hl7-fhir-r4-core/UsageContext";

export interface ValueSetCompose extends BackboneElement {
    exclude?: ValueSetComposeInclude[];
    inactive?: boolean;
    include: ValueSetComposeInclude[];
    lockedDate?: string;
}

export interface ValueSetComposeInclude extends BackboneElement {
    concept?: ValueSetComposeIncludeConcept[];
    filter?: ValueSetComposeIncludeFilter[];
    system?: string;
    valueSet?: string[];
    version?: string;
}

export interface ValueSetComposeIncludeConcept extends BackboneElement {
    code: string;
    designation?: ValueSetComposeIncludeConceptDesignation[];
    display?: string;
}

export interface ValueSetComposeIncludeConceptDesignation extends BackboneElement {
    language?: ("ar" | "bn" | "cs" | "da" | "de" | "de-AT" | "de-CH" | "de-DE" | "el" | "en" | "en-AU" | "en-CA" | "en-GB" | "en-IN" | "en-NZ" | "en-SG" | "en-US" | "es" | "es-AR" | "es-ES" | "es-UY" | "fi" | "fr" | "fr-BE" | "fr-CH" | "fr-FR" | "fy" | "fy-NL" | "hi" | "hr" | "it" | "it-CH" | "it-IT" | "ja" | "ko" | "nl" | "nl-BE" | "nl-NL" | "no" | "no-NO" | "pa" | "pl" | "pt" | "pt-BR" | "ru" | "ru-RU" | "sr" | "sr-RS" | "sv" | "sv-SE" | "te" | "zh" | "zh-CN" | "zh-HK" | "zh-SG" | "zh-TW" | string);
    use?: Coding<("900000000000003001" | "900000000000013009" | string)>;
    value: string;
}

export interface ValueSetComposeIncludeFilter extends BackboneElement {
    op: ("=" | "is-a" | "descendent-of" | "is-not-a" | "regex" | "in" | "not-in" | "generalizes" | "exists");
    property: string;
    value: string;
}

export interface ValueSetExpansion extends BackboneElement {
    contains?: ValueSetExpansionContains[];
    identifier?: string;
    offset?: number;
    parameter?: ValueSetExpansionParameter[];
    timestamp: string;
    total?: number;
}

export interface ValueSetExpansionContains extends BackboneElement {
    abstract?: boolean;
    code?: string;
    contains?: ValueSetExpansionContains[];
    designation?: ValueSetComposeIncludeConceptDesignation[];
    display?: string;
    inactive?: boolean;
    system?: string;
    version?: string;
}

export interface ValueSetExpansionParameter extends BackboneElement {
    name: string;
    valueBoolean?: boolean;
    valueCode?: string;
    valueDateTime?: string;
    valueDecimal?: number;
    valueInteger?: number;
    valueString?: string;
    valueUri?: string;
}

// CanonicalURL: http://hl7.org/fhir/StructureDefinition/ValueSet (pkg: hl7.fhir.r4.core#4.0.1)
export interface ValueSet extends DomainResource {
    resourceType: "ValueSet";

    compose?: ValueSetCompose;
    contact?: ContactDetail[];
    copyright?: string;
    date?: string;
    description?: string;
    expansion?: ValueSetExpansion;
    experimental?: boolean;
    identifier?: Identifier[];
    immutable?: boolean;
    jurisdiction?: CodeableConcept[];
    name?: string;
    publisher?: string;
    purpose?: string;
    status: ("draft" | "active" | "retired" | "unknown");
    title?: string;
    url?: string;
    useContext?: UsageContext[];
    version?: string;
}
export const isValueSet = (resource: unknown): resource is ValueSet => {
    return resource !== null && typeof resource === "object" && (resource as {resourceType: string}).resourceType === "ValueSet";
}
